export default {
  methods   : {
    UXWaiting(time = 1000){
      return new Promise(resolve => setTimeout(resolve, time));
    },

    waitLoading(loadingObj, waitTime = 1000, tryTime = 5){
      return new Promise((resolve) => {
        const intervalId = setInterval(() => {
          if(loadingObj === false){
            clearInterval(intervalId);
            resolve();
          }
        }, waitTime);

        setTimeout(() => {
          clearInterval(intervalId);
          resolve();
        }, (waitTime * tryTime));
      });
    },

    // 指定したアイテムストアから指定数を引いたあとのアイテム数情報を取得します。
    getItemStoreAmount(itemStoreData, quantity){
      const results = {
        quantity  : quantity,
        total     : 0,
        remain    : 0,
        couldUse  : false,  // 所有数から必要数を引いてもマイナスにならない場合、使用可能なのでtrueとなります。
      };

      results.total  = itemStoreData.quantity;
      results.remain = (results.total - results.quantity);

      if(results.remain < 0){
        results.couldUse = false;
      }else{
        results.couldUse = true;
      }

      if(results.remain < 0){
        results.remain = 0;
      }

      return results;
    },

    textReplacer(templateText, replaceItems){
      let replacingText = templateText;

      if(replaceItems === null){
        return replacingText;
      }
      
      for(let key in replaceItems){
        if(typeof replaceItems[key] === 'object'){
          for(let key2 in replaceItems[key]){
            const regex = new RegExp('\\[\\['+key+'.'+key2+'\\]\\]', 'g');
            replacingText = replacingText.replace(regex, replaceItems[key][key2]);
          }
        }else{
          const regex = new RegExp('\\[\\['+key+'\\]\\]', 'g');
          replacingText = replacingText.replace(regex, replaceItems[key]);
        }
      }

      return replacingText;
    },

    forcefulReloading(){
      if( confirm('アプリの再読み込みを実行します。よろしいですか？') ){
        if ('serviceWorker' in navigator) {
          caches.keys().then(function(cacheNames) {
            cacheNames.forEach(function(cacheName) {
              caches.delete(cacheName);
            });
          });
        }

        window.location.reload();
      }else{
        return false;
      }
    },

    getClientRectHeight(element){
      const clientRect = element.getBoundingClientRect();

      return clientRect.height;
    }
  }
}